<template>
  <div class="round-selector-dialog">
    <h4 class="dialog-title">
      <i class="fal fa-exchange"></i>
      ປ່ຽນຮອບການຄັດແຍກ
    </h4>

    <div class="current-info">
      <p>ເຄື່ອງ: <strong>{{ machineCode }}</strong></p>
      <p>ຮອບປັດຈຸບັນ: <strong>ຮອບ {{ currentRound }}</strong></p>
    </div>

    <div class="round-selection">
      <label class="label">ເລືອກຮອບໃໝ່</label>
      <div class="rounds-list">
        <div
            v-for="round in rounds"
            :key="round.round"
            :class="['round-option', {
              selected: selectedRound === round.round,
              current: currentRound === round.round
            }]"
            @click="selectedRound = round.round"
        >
          <div class="round-header">
            <span class="round-label">ຮອບ {{ round.round }}</span>
            <span v-if="currentRound === round.round" class="current-badge">ປັດຈຸບັນ</span>
          </div>
          <div class="round-details">
            <span>{{ round.branch_count }} ສາຂາ</span>
            <span class="range">({{ round.branch_range }})</span>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <vs-button flat @click="$emit('close')">ຍົກເລີກ</vs-button>
      <vs-button
          primary
          flat
          @click="confirmSwitch()"
          :loading="isLoading"
          :disabled="selectedRound === currentRound"
      >
        <i class="fal fa-check" style="margin-right: 5px;"></i> ຢືນຢັນປ່ຽນຮອບ
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoundSelectorDialog',

  props: {
    rounds: {
      type: Array,
      default: () => []
    },
    currentRound: {
      type: Number,
      default: 1
    },
    machineCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      selectedRound: this.currentRound,
      isLoading: false
    };
  },

  methods: {
    confirmSwitch() {
      if (this.selectedRound !== this.currentRound) {
        this.$emit('success', this.selectedRound);
      }
    }
  },

  watch: {
    currentRound: {
      immediate: true,
      handler(val) {
        this.selectedRound = val;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.round-selector-dialog {
  padding: 10px;
}

.dialog-title {
  font-weight: bold;
  color: #195BFF;
  font-size: 18px;
  margin-bottom: 20px;

  i {
    margin-right: 8px;
  }
}

.current-info {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;

  p {
    margin: 5px 0;
    color: #666;

    strong {
      color: #333;
    }
  }
}

.round-selection {
  margin-bottom: 20px;
}

.rounds-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.round-option {
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #195BFF;
    background: #f5f8ff;
  }

  &.selected {
    border-color: #195BFF;
    background: #f5f8ff;
  }

  &.current {
    border-color: #4caf50;
    background: #e8f5e9;
  }

  .round-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }

  .round-label {
    font-weight: 600;
    color: #333;
    font-size: 16px;
  }

  .current-badge {
    background: #4caf50;
    color: white;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
  }

  .round-details {
    font-size: 13px;
    color: #666;

    .range {
      margin-left: 5px;
      color: #999;
    }
  }
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}
</style>
